import jsPDF from "jspdf";
import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters(["findPlayerInScore"]),
  },

  methods: {
    generatePdf(score) {
      const pdf = new jsPDF("landscape", "px", "a4");
      const img = new Image();
      img.src = require("@/assets/scoreCard.png"); // Pfad zum Hintergrundbild

      img.onload = () => {
        // Hintergrundbild hinzufügen
        pdf.addImage(
          img,
          "PNG",
          0,
          0,
          pdf.internal.pageSize.width,
          pdf.internal.pageSize.height
        );

        // Zeichne ein Grid
        // this.drawGrid(pdf);
        // Beispiel: Spielinformationen hinzufügen
        const guest = this.getTeamName("guest", score);
        const home = this.getTeamName("home", score);

        pdf.setFontSize(10);
        pdf.text(`${score.info.competition}`, 510, 88);
        pdf.text(`${score.info.place}`, 510, 101);
        pdf.text(`${score.info.date}`, 510, 114);
        pdf.text(`${score.info.game}`, 510, 127);
        pdf.text(`${score.info?.set}`, 580, 127);
        pdf.text(`${guest}`, 510, 140);
        pdf.text(`${home}`, 510, 153);

        // Spielerinformationen für Home und Visitor hinzufügen
        const homeLineUp = this.getLineUp("home", score);
        const guestLineUp = this.getLineUp("guest", score);
        const homeSubLineUp = this.getSubLineUp("home", score);
        const guestSubLineUp = this.getSubLineUp("guest", score);

        this.addLineUpToPdf(pdf, guestLineUp, "guest", 41, 100);
        this.addLineUpToPdf(pdf, homeLineUp, "home", 41, 247);
        this.addSubLineUpToPdf(pdf, guestSubLineUp, "guest", 59, 112);
        this.addSubLineUpToPdf(pdf, homeSubLineUp, "home", 59, 259);

        const groupedHomePlays = this.groupedPlays("home");
        const groupedGuestPlays = this.groupedPlays("guest");
        this.addInningsToPdf(pdf, groupedHomePlays, "home", 171, 238);
        this.addInningsToPdf(pdf, groupedGuestPlays, "guest", 171, 91);

        // Runs und Errors
        this.addRunsToPdf(pdf, score, 155, 396);
        pdf.text(`${score.inning[0]?.play[0]?.score["guest"]}`, 388, 396);
        pdf.text(`${score.inning[0]?.play[0]?.score["home"]}`, 388, 420);

        this.addErrorsToPdf(pdf, score, 483, 397);
        const homeErrors = this.countErrors(score.inning, "home");
        const guestErrors = this.countErrors(score.inning, "guest");
        pdf.text(`${homeErrors}`, 601, 414);
        pdf.text(`${guestErrors}`, 601, 397);

        pdf.text(`${score.startTime}`, 89, 411);
        pdf.text(`${score.endTime}`, 89, 423);

        //officials
        pdf.text(`${score.officials.homePlateOfficial}`, 453, 196);
        pdf.text(`${score.officials.firstBaseOfficial}`, 453, 221);
        pdf.text(`${score.officials.secondBaseOfficial}`, 453, 246);
        pdf.text(`${score.officials.thirdBaseOfficial}`, 453, 271);
        pdf.text(`${score.officials.tableOfficial}`, 453, 296);
        // PDF speichern
        pdf.save("scorecard.pdf");
      };
    },

    groupedPlays(team) {
      return this.score.inning
        .slice() // Erstelle eine Kopie des Arrays, um das Original nicht zu verändern
        .reverse() // Kehre die Reihenfolge der Innings um
        .filter((inning) => inning.play && inning.play.length > 0) // Filtere Innings mit gültigen Plays
        .map((inning) => {
          // Filtere Plays für das angegebene Team

          const offsetPlays = inning.play
            .filter(
              (play) =>
                play.team === team &&
                (play.action === "hit" ||
                  play.action === "safe" ||
                  play.action === "scored" ||
                  play.action === "out" ||
                  play.action === "batterout" ||
                  play.action === "runner")
            )
            .reverse();
          const filteredPlays = inning.play
            .filter(
              (play) =>
                play.team === team &&
                (play.action === "hit" ||
                  play.action === "safe" ||
                  play.action === "scored" ||
                  play.action === "out" ||
                  play.action === "batterout" ||
                  play.action === "runner" ||
                  play.action === "substitute")
            )
            .reverse();

          // Wenn keine Plays für das Team vorhanden sind, überspringen
          if (offsetPlays.length === 0) return [];

          // Prüfe den Offset: Finde den `lineup`-Wert des ersten Plays
          const firstLineup = offsetPlays[0]?.lineup - 1 || 0;
          const offset =
            firstLineup === 1 ? 0 : firstLineup === 0 ? 4 : firstLineup - 1;
          // Füge leere Plätze für das Offset hinzu
          const adjustedPlays = [];
          for (let i = 1; i <= offset; i++) {
            adjustedPlays.push({
              lineup: i,
              action: "",
              isPlaceholder: true,
              lineUpPosition: { guest: i, home: i },
            });
          }

          // Füge die bereinigten Plays hinzu
          adjustedPlays.push(...filteredPlays);

          // Gruppiere die Plays basierend auf `lineup`
          const groups = [];
          let currentGroup = [];
          let previousPlayWasSubstitute = false; // Track if the previous play was a substitute

          adjustedPlays.forEach((play, index) => {
            if (previousPlayWasSubstitute) {
              // Use the information that the previous play was a substitute
              play.relatedAction = "substitute";
            }

            if (play.action === "substitute") {
              previousPlayWasSubstitute = true; // Set the flag for the next play
              return; // Skip the substitute play itself
            } else {
              previousPlayWasSubstitute = false; // Reset the flag if the current play is not a substitute
            }
            if (play.action === "scored" || play.action === "out") {
              // Suche in den vorherigen Plays nach einem Play mit 'hit' oder 'safe'
              for (let i = index - 1; i >= 0; i--) {
                const previousPlay = adjustedPlays[i];
                // console.log('previousPlay', previousPlay);
                if (play.playerId !== previousPlay.playerId) {
                  // Überspringe Plays mit unterschiedlichen Spieler-IDs
                  continue;
                }
                if (
                  previousPlay.action === "out" ||
                  previousPlay.action === "scored"
                ) {
                  // Überspringe Plays mit 'out' oder 'scored'
                  continue;
                }
                if (
                  previousPlay.action === "hit" ||
                  previousPlay.action === "safe" ||
                  previousPlay.action === "runner"
                ) {
                  // Schreibe die `relatedAction` in das `previousPlay`
                  previousPlay.relatedAction = play.action;
                  break;
                }
              }
              return;
            }

            currentGroup.push(play);
            // Schließe die Gruppe ab, wenn `lineup` 5 erreicht
            if (currentGroup.length === 5) {
              groups.push(currentGroup);
              currentGroup = [];
            }
          });

          // Letzte Gruppe hinzufügen, falls noch Plays übrig sind
          if (currentGroup.length > 0) {
            groups.push(currentGroup);
          }

          return groups;
        });
    },
    getLineUp(team, score) {
      const players = this.findTeam(team, score)
        .filter((player) => player.lineUpPosition !== undefined) // Optional: Nur Spieler mit lineUpPosition
        .sort((a, b) => a.lineUpPosition - b.lineUpPosition) // Nach Position sortieren
        .slice(0, 5);
      const lineUp = players.map((player) => ({
        ...player, // Ursprüngliche Informationen des Spielers
        ...this.findPlayerInScore(player.id), // Zusätzliche Daten aus this.teams
      }));
      return lineUp;
    },
    getSubLineUp(team, score) {
      let lineUp = Array(5).fill(null); // Initialisiere ein Array mit 5 Elementen (alle `null`)

      for (const inning of score.inning) {
        const plays = inning.play.filter(
          (play) => play.action === "substitute" && play.team === team
        );

        for (const play of plays) {
          const player = this.findPlayerInScore(play.playerId);
          if (player) {
            const lineUpPosition = play.positions[play.team].find(
              (player) => player.id === play.playerId
            )?.lineUpPosition;

            // Füge den Spieler an der entsprechenden Position ein, wenn die Position gültig ist
            if (lineUpPosition >= 1 && lineUpPosition <= 5) {
              lineUp[lineUpPosition - 1] = {
                ...player,
                lineUpPosition,
              };
            }
          }
        }
      }
      return lineUp;
    },
    getTeamName(teamSide, score) {
      const team = score.teams.find((t) => t.teamSide === teamSide);
      return team ? team.name : "Unknown Team";
    },
    findTeam(teamSide, score) {
      for (const inning of score.inning) {
        const startPlay = inning.play.find((play) => play.action === "start");
        if (startPlay) {
          return startPlay.positions[teamSide]; // Gibt das erste gefundene Play mit der Aktion 'start' zurück
        }
      }
    },

    addLineUpToPdf(pdf, lineUp, team, startX, startY) {
      const lineHeight = 23.5; // Abstand zwischen den Zeilen

      pdf.setFontSize(10);
      lineUp.forEach((player, index) => {
        const y = startY + index * lineHeight;
        pdf.text(`${player.name || "Unknown"}`, startX, y);
        pdf.text(`${player.gender || "-"}`, startX + 109, y);
        pdf.text(`${player.number || "-"}`, startX + 121, y);
      });
    },
    addSubLineUpToPdf(pdf, subLineUp, team, startX, startY) {
      const lineHeight = 23.5; // Abstand zwischen den Zeilen

      pdf.setFontSize(10);
      subLineUp.forEach((player, index) => {
        if (!player) return; // Überspringe leere Einträge
        const y = startY + index * lineHeight;
        pdf.text(`${player.name || "Unknown"}`, startX, y);
        pdf.text(`${player.gender || "-"}`, startX + 91, y);
        pdf.text(`${player.number || "-"}`, startX + 103, y);
      });
    },
    addInningsToPdf(pdf, groupedPlays, team, startX, startY) {
      const columnWidth = 23.5; // Breite jeder Spalte
      const rowHeight = 23.5; // Höhe jeder Zeile
      let xGroup = startX;

      groupedPlays.forEach((inningGroups, inningIndex) => {
        inningGroups.forEach((group, groupIndex) => {
          pdf.setFontSize(10);
          // pdf.setFillColor(0, 0, 255); // Set fill color to blue
          // pdf.rect(xGroup, startY - 10, 10, 10, "F"); // Draw a blue square
          pdf.text(String(inningIndex + 1), xGroup + 3, startY - 3);

          pdf.setFontSize(25);
          group.forEach((play, playIndex) => {
            const y = startY + rowHeight * playIndex;
            if (play.relatedAction === "substitute") {
              pdf.setDrawColor(0, 0, 0); // Set line color to red
              pdf.setLineWidth(2); // Set line width
              pdf.line(xGroup + 1, y + 2, xGroup + 1, y + 2 + 20); // Draw a red line
            }
            if (play.relatedAction === "scored") {
              pdf.setDrawColor(0, 0, 0); // Set line color to black
              pdf.setLineWidth(2); // Set line width
              pdf.circle(xGroup + 11, y + 12, 10); // Draw a circle with center (xGroup + 10, y + 12) and radius 10
            }
            // Draw a line for the last play in the group
            if (
              groupIndex === inningGroups.length - 1 &&
              playIndex === group.length - 1
            ) {
              pdf.setDrawColor(0, 0, 0); // Set line color to black
              pdf.setLineWidth(2); // Set line width
              pdf.line(xGroup, y + 21, xGroup + 20, y + 21); // Draw a horizontal line
            }
            // pdf.setFillColor(0, 134, 255); // Set fill color to blue
            // pdf.rect(xGroup, y + 2, 20, 20, "F"); // Draw a blue square
            pdf.text(this.displayAction(play.action), xGroup + 4, y + 19);
          });
          xGroup += columnWidth;
        });
      });
    },
    displayAction(action) {
      switch (action) {
        case "hit":
          return "H";
        case "safe":
          return "H";
        case "scored":
          return "O";
        case "out":
          return "X";
        case "batterout":
          return "X";
        case "runner":
          return "R";
        case "substitute":
          return "";
        default:
          return action.charAt(0).toUpperCase() + action.slice(1);
      }
    },
    addRunsToPdf(pdf, score, startX, startY) {
      const rowWidth = 23.5; // Abstand zwischen den Spalten
      const rowHeight = 24; // Abstand zwischen den Zeilen

      pdf.setFontSize(20);

      // Runs für Guest-Team
      score.inning.reverse().forEach((inning, index) => {
        const runs = inning.play.filter(
          (play) => play.team === "guest" && play.action === "scored"
        ).length;
        pdf.text(`${runs}`, startX + (index + 1) * rowWidth, startY);
      });
      // Runs für Home-Team
      score.inning.reverse().forEach((inning, index) => {
        const runs = inning.play.filter(
          (play) => play.team === "home" && play.action === "scored"
        ).length;
        pdf.text(
          `${runs}`,
          startX + (index + 1) * rowWidth,
          startY + rowHeight
        );
      });
    },
    addErrorsToPdf(pdf, score, startX, startY) {
      const rowWidth = 11.5; // Abstand zwischen den Spalten
      const rowHeight = 16; // Abstand zwischen den Zeilen

      pdf.setFontSize(10);

      // Errors für Home-Team
      const homeErrors = score.inning.flatMap((inning) =>
        inning.play.filter(
          (play) => play.team === "home" && play.action === "error"
        )
      );
      homeErrors.forEach((_, index) => {
        const x = startX + index * rowWidth;
        pdf.text("X", x, startY + rowHeight);
      });

      // Errors für Guest-Team
      const guestErrors = score.inning.flatMap((inning) =>
        inning.play.filter(
          (play) => play.team === "guest" && play.action === "error"
        )
      );
      guestErrors.forEach((_, index) => {
        const x = startX + index * rowWidth;
        pdf.text("X", x, startY);
      });
    },
    countErrors(innings, team) {
      if (!Array.isArray(innings)) {
        return 0;
      }
      const errors = innings.reduce((total, inning) => {
        // Skip null oder ungültige Innings
        if (!Array.isArray(inning.play) || inning.play.length === 0)
          return total;

        // Zähle alle Plays in diesem Inning mit dem gesuchten Action
        const inningErrors = inning.play.reduce((count, play) => {
          if (!play || !play.action) return count;
          const hasError = play.action === "error" && play.team === team;
          return count + (hasError ? 1 : 0);
        }, 0);

        return total + inningErrors;
      }, 0);

      return errors;
    },
    drawGrid(pdf) {
      const pageWidth = pdf.internal.pageSize.width;
      const pageHeight = pdf.internal.pageSize.height;

      pdf.setDrawColor(200); // Setze die Farbe des Grids (hellgrau)
      pdf.setLineWidth(0.2); // Setze die Linienbreite

      // Vertikale Linien
      for (let x = 0; x <= pageWidth; x += 20) {
        pdf.line(x, 0, x, pageHeight); // Linie von oben nach unten
        pdf.text(String(x), x + 2, 10); // Beschrifte die Linie
      }

      // Horizontale Linien
      for (let y = 0; y <= pageHeight; y += 20) {
        pdf.line(0, y, pageWidth, y); // Linie von links nach rechts
        pdf.text(String(y), 2, y + 10); // Beschrifte die Linie
      }
    },
  },
};
